export const gitCommit = 'c349aa0d'
